import PropTypes from "prop-types";
import ListContainer from "../../atoms/ListContainer";
import { NavLink } from "react-router-dom";
import NavAccordionMenu from "../../molecules/NavAccordionMenu";

const MobileNavLinks = ({ mobileNavItems, onClick }) => {
  const mobileNavItem = mobileNavItems
    ? mobileNavItems.map((item) => {
        if (item.links.length > 1) {
          return (
            <NavAccordionMenu
              key={item.slug}
              menuLink={item}
              id={`${item.slug}`}
              onClick={onClick}
            />
          );
        } else {
          return (
            <li key={item.slug} className="mobile-nav-links__item">
              <NavLink
                to={`/${item.links[0].path}`}
                exact={item.links[0].path === ""} // ensure Home page does not stay permanently active
                aria-label={`Visit ${item.name}`}
                onClick={onClick}
              >
                {item.name}
              </NavLink>
            </li>
          );
        }
      })
    : null;
  return (
    <div className="mobile-nav-links__container">
      <ListContainer>{mobileNavItem}</ListContainer>
    </div>
  );
};

MobileNavLinks.propTypes = {
  mobileNavItems: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      slug: PropTypes.string,
      links: PropTypes.arrayOf(
        PropTypes.shape({ name: PropTypes.string, path: PropTypes.string, exact: PropTypes.bool })
      ),
    })
  ),
  onClick: PropTypes.func,
};

export default MobileNavLinks;
